import React from 'react';
import { ReaderPathCheck } from './ReaderPathCheck';
import { Reveal } from './Reveal';
import { PathThread } from './PathThread';
export function BusinessValue() {
  const outcomes = ['Serious readers have a useful next step', 'You can see what readers care about', 'Different readers can move toward better-fit offers', 'The book keeps feeding your content, talks, and sales conversations'];
  const contentOutputs = ['Posts', 'Emails', 'Podcast points', 'Workshop prompts', 'Sales follow-up', 'Course lessons', 'Certification ideas', 'Event themes'];
  return <section className="py-24 px-6 max-w-4xl mx-auto border-t border-gray-200 bg-paper-dark relative" data-id="element-15">
      <div className="absolute -top-12 left-1/2 -translate-x-1/2" data-id="element-16">
        <PathThread data-id="element-17" />
      </div>

      <div className="text-center mb-20" data-id="element-18">
        <Reveal data-id="element-19">
          <h2 className="text-3xl md:text-5xl font-serif text-navy mb-6 leading-tight" data-id="element-20">
            Your book should keep <br data-id="element-21" />
            <span className="italic text-seaglass" data-id="element-22">working after launch</span>
          </h2>
        </Reveal>
      </div>

      <div className="grid sm:grid-cols-2 gap-6 mb-32" data-id="element-23">
        {outcomes.map((outcome, idx) => <Reveal key={idx} delay={0.1 * idx} data-id="element-24">
            <div className="bg-white border border-gray-100 rounded-2xl p-8 shadow-[0_8px_20px_-12px_rgba(26,40,56,0.15)] flex items-start gap-4 hover:-translate-y-1 transition-transform duration-300" data-id="element-25">
              <div className="w-8 h-8 rounded-full bg-seaglass/10 text-seaglass flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-26">
                <div className="w-2.5 h-2.5 rounded-full bg-seaglass" data-id="element-27"></div>
              </div>
              <span className="font-serif text-lg text-navy" data-id="element-28">{outcome}</span>
            </div>
          </Reveal>)}
      </div>

      {/* Content Source Engine Sub-Band */}
      <div className="mb-24" data-id="element-29">
        <div className="text-center mb-16" data-id="element-30">
          <Reveal data-id="element-31">
            <h3 className="text-3xl md:text-4xl font-serif text-navy mb-6 leading-tight" data-id="element-32">
              The book already gave you <br data-id="element-33" />
              <span className="italic text-seaglass" data-id="element-34">more to say</span>
            </h3>
          </Reveal>
          <Reveal delay={0.1} data-id="element-35">
            <p className="text-lg text-text-muted leading-relaxed max-w-2xl mx-auto" data-id="element-36">
              Your book already contains frameworks, stories, questions,
              objections, teaching moments, and reader problems. Those should
              keep feeding:
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.2} data-id="element-37">
          <div className="relative max-w-3xl mx-auto py-16" data-id="element-38">
            {/* Central Book IP hub */}
            <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 bg-navy text-paper px-9 py-6 rounded-2xl shadow-[0_18px_40px_-14px_rgba(26,40,56,0.45)] z-10 font-serif text-xl text-center border-4 border-seaglass font-semibold" data-id="element-39">
              Book IP
            </div>

            {/* Outputs arranged around */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-10 relative z-0" data-id="element-40">
              {contentOutputs.map((output, idx) => <div key={idx} className="relative flex justify-center" data-id="element-41">
                  <div className={`bg-paper-dark border border-gray-200 rounded-full px-4 py-2 text-center text-sm font-medium text-navy shadow-sm
                    ${idx === 0 || idx === 3 || idx === 4 || idx === 7 ? 'md:translate-y-0' : 'md:translate-y-20'}
                    ${idx < 4 ? 'mb-12 md:mb-0' : 'mt-12 md:mt-0'}
                  `} data-id="element-42">
                    {output}
                  </div>
                  {/* Faint connecting lines (simplified CSS representation) */}
                  <div className={`absolute w-px bg-seaglass/30 -z-10
                    ${idx < 4 ? 'top-full bottom-[-3rem] md:bottom-[-5rem]' : 'bottom-full top-[-3rem] md:top-[-5rem]'}
                  `} data-id="element-43"></div>
                </div>)}
            </div>
          </div>
        </Reveal>
      </div>

      <Reveal delay={0.3} data-id="element-44">
        <div id="quick-check-4" className="scroll-mt-32" data-id="element-45">
          <ReaderPathCheck id="q4" checkLabel="Quick Check · 4 of 8" question="When you create a new campaign, webinar, lead magnet, post, or sales conversation, how often does the book shape it?" answers={[{
          id: 'a',
          label: 'A',
          text: 'Rarely. The book mostly sits apart from my current marketing or sales motion.'
        }, {
          id: 'b',
          label: 'B',
          text: 'Sometimes. I reference the book, but new campaigns often get built separately.'
        }, {
          id: 'c',
          label: 'C',
          text: 'Often. The book gives me topics, language, stories, or frameworks to use.'
        }, {
          id: 'd',
          label: 'D',
          text: "Consistently. The book's concepts are mapped into campaigns, content, talks, CTAs, and offer paths."
        }]} confirmationText="Saved. You're halfway there." data-id="element-46" />
        </div>
      </Reveal>
    </section>;
}